import Logger from '../base/logger';

Logger.prefix = 'WC CLOSER:';

const uuidv4 = () =>
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });

Logger.traceId = uuidv4();
Logger.logToCloserApi = (message) => {
    if (!window.WC.Closer._enableCloserLog) {
        return;
    }

    const logEntry = {
        message,
        level: 'info',
        externalTraceId: Logger.traceId,
        url: window.location.href,
        stack: Error().stack
    };

    fetch(`${window.WC.Closer._closerScriptBaseUrl}/api/q`, {
        method: 'POST',
        body: JSON.stringify({ logs: [logEntry] }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
Logger.logToCloser = (message) => {
    if (!window.WC.Closer._enableCloserLog) {
        return;
    }
    window.closer.log &&
        window.closer.log({
            message: message
        });
};

export default Logger;
